import http from "./httpService";

const apiEndpoint = process.env.REACT_APP_API_PROSPECTSALESTOOL_URL;

export async function GetValueCalculatorOutput(request) {
    request.screen = "CalculatorInput";
    request.action = "Submit";
    request.user_id = localStorage.getItem('user_id');
    http.addBearerAuthorization();
    return await http.post(apiEndpoint + "/Calculator/GetCalculatorOutputDetails", request);
}

export async function GetValueCalculatorInputData(filters) {
    filters.screen = "CalculatorFilter";
    filters.action = "Submit";
    filters.user_id = localStorage.getItem('user_id');
    http.addBearerAuthorization();
    return await http.post(apiEndpoint + "/Calculator/GetCalculatorInputDetails", filters);
}

export async function GetConversationDataDetails(marketId) {
    http.addBearerAuthorization();
    return await http.post(apiEndpoint + "/Calculator/GetCalculatorConversationDataDetails", {market_id: marketId});
}

export default {
    GetValueCalculatorOutput,
    GetValueCalculatorInputData,
    GetConversationDataDetails
}
